import React, {useState, useEffect} from "react"

// data
import Data from "../../../../data"

// components
import Features from "./Features"

function Options({activity}) {
  // state
  const [items, setItems] = useState([])


  // side effects
  useEffect(() => {
    // get items
    if(activity) {
      let optionItems = Data.Activity.getAllOptions(activity).map(o => {
        return {key:o.name, text:o.name}
      })
      // update the state
      setItems(optionItems)
    }
    else {
      setItems([])
    }
  }, [activity])

  // render
  if(items.length === 0) {
    return null
  }
  else {
    return (
      <Features 
        title="Verfügbare Optionen" 
        items={items}
      />
    )
  }
}

export default Options